import { RESET_APP, ENABLE_KIOSK_MODE, DISABLE_KIOSK_MODE } from '../../constants/action_types';

const defaultState = {
  isKiosk: false,
  isLoading: false,
};

const globalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ENABLE_KIOSK_MODE:
      return {
        ...state,
        isKiosk: true,
      };
    case DISABLE_KIOSK_MODE:
      return {
        ...state,
        isKiosk: false,
      };
    case RESET_APP:
      return defaultState;
    default:
      return state;
  }
};

export default globalReducer;
